import { object } from 'yup';

import { initialPassword, email } from '@/constants/validation';

export const schema = object({
  email,
  password: initialPassword,
}).required();
